import React, {useEffect, useState} from "react";


import {
    Navigate,
    Route, Routes
} from "react-router-dom";

import {
    Container,
    Row
} from "react-bootstrap";


import {
    UseQyvoUser
} from "@Store/@Hooks";


import UserDashboardHomePageComponent from "@Pages/@@UserPages/@@Dashboard/@@Home";
import UserDashboardSubmitRequestPageComponent from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest";
import UserDashboardWalletPageComponent from "@Pages/@@UserPages/@@Dashboard/@Wallet";


import "./index.scss";
import {UseUserSignInAction} from "@Store/@Hooks/@@Actions";
import UserDashboardProfilePage from "@Pages/@@UserPages/@Dashboard/@Profile";
import UserDashboardSettingsPage from "@Pages/@@UserPages/@Dashboard/@Settings";
import UserDashboardPrivacyAndSecurityPage from "@Pages/@@UserPages/@Dashboard/@Security";



export const UserDashboardPage:React.FC = () => {


    const UserSignInAction = UseUserSignInAction();


    const QyvoUser = UseQyvoUser();


    const [User, setUser] = useState(null);

    useEffect(() => {

        if (!QyvoUser || QyvoUser?.qyvoUserFirstName) {
            return;
        }

        const getUser = async () => {
            try {
                const response = await fetch(
                    `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/get-user-by-email/?user_email=${QyvoUser.qyvoUserEmail}&user_data=true`
                );
                if (response.ok) {
                    const data = await response.json();
                    setUser(data);
                    UserSignInAction({
                        qyvoUserID: data.qyvo_user_id,
                        qyvoUserEmail: data.qyvo_user_email,
                        qyvoUserFirstName: data.qyvo_user_first_name,
                        qyvoUserLastName: data.qyvo_user_last_name,
                        qyvoUserProfilePicture: data.qyvo_user_profile_picture,
                    });
                }
            } catch (e) {

            }
        };

        getUser();

    }, [QyvoUser]);


    if (!QyvoUser) {
        return <Navigate to={'/sign-in'} replace />;
    }


    return (
        <Container fluid={true} className={`page-container-component page-container-component--default-container`}>
            <Container className={`page-container-component__container-content page-container-component--default-container__container-content`}>
                <Row className={`page-container-component__container-content__container-row page-container-component--default-container__container-content__container-row`}>

                    <Routes>

                        <Route
                            index element={<UserDashboardHomePageComponent />}
                        />

                        <Route
                            path={'submit-request'} element={<UserDashboardSubmitRequestPageComponent />}
                        />

                        <Route
                            path={'profile'} element={<UserDashboardProfilePage />}
                        />

                        <Route
                            path={'settings'} element={<UserDashboardSettingsPage />}
                        />

                        <Route
                            path={'wallet'} element={<UserDashboardWalletPageComponent />}
                        />

                        <Route
                            path={'security'} element={<UserDashboardPrivacyAndSecurityPage />}
                        />

                    </Routes>


                </Row>
            </Container>
        </Container>
    );

};


export default UserDashboardPage;
